module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sidebar":{"menu":{"documents":"Documents","settings":"Settings","logout":"Logout"}}},"es":{"sidebar":{"menu":{"documents":"Documentos","settings":"Ajustes","logout":"Cierre de sesión"}}},"fr":{"sidebar":{"menu":{"documents":"Documents","settings":"Paramètres","logout":"Déconnexion"}}},"pt":{"sidebar":{"menu":{"documents":"Documentos","settings":"Configurações","logout":"Sair"}}},"de":{"sidebar":{"menu":{"documents":"Dokumente","settings":"Einstellungen","logout":"Abmeldung"}}},"nl":{"sidebar":{"menu":{"documents":"Documenten","settings":"Instellingen","logout":"Uitloggen"}}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@intlify/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/modules/app/components/AppBurger.vue
// module id = F9YZ
// module chunks = 10